export default "images/037 减速让行.png";